import React, { useContext, useEffect, useRef } from 'react'
import { dataContext, localestr } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import EditImg from '../cmp/EditImg.js';
import Panel from '../cmp/Panel'
import icon from '../icons.svg'
import { useState } from 'react';
import { createQR } from './servQRDesign.js';
import logoImg from '../logo192.png';
import Info from '../cmp/info.js';

let langCount = 0;

export function MenuCanvas({ iconHeader, colorIcons, colorBg, textColor, mainText }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    canvas.width = 250;
    canvas.height = 400;

    // --- Функції малювання ---
    const drawRoundedRect = (ctx, x, y, w, h, r) => {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + w - r, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r);
      ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
      ctx.closePath();
    };

    const drawButton = (ctx, x, y, w, h, r, text, font = "bold 12px Arial") => {
      ctx.save();
      ctx.fillStyle = textColor;
      drawRoundedRect(ctx, x, y, w, h, r);
      ctx.fill();

      ctx.fillStyle = colorBg;
      ctx.font = font;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(text, x + w / 2, y + h / 2);
      ctx.restore();
    };

    // --- Малюємо фон і логотип ---
    ctx.fillStyle = colorBg;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const img = new Image();
    img.src = iconHeader;
    img.onload = () => {
      ctx.drawImage(img, 0, 0, canvas.width, 150);

      // Текст по центру логотипу
      ctx.fillStyle = textColor;
      ctx.font = "bold 35px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(mainText, canvas.width / 2, 75);

      // --- Бургер ---
      const iconSize = 18;
      const padding = 10;
      let x = canvas.width - padding - iconSize;
      ctx.fillStyle = colorIcons;
      for (let i = 0; i < 3; i++) ctx.fillRect(x, padding + i * 6, iconSize, 2);

      // --- Телефон SVG ---
      const svgPhone = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" fill="${colorIcons}"><path d="M23.45 20.93a3 3 0 0 0-4.25 0l-1.45 1.45a26.14 26.14 0 0 1-4.51-3.62 26.62 26.62 0 0 1-3.62-4.51l1.45-1.45a3 3 0 0 0 0-4.25L8.24 5.73a2.93 2.93 0 0 0-2.11-.88A3 3 0 0 0 4 5.73L2.64 7.08A6.37 6.37 0 0 0 1 12.33c.32 3.75 2.78 8.26 6.57 12.06S15.92 30.64 19.67 31a7.87 7.87 0 0 0 .84 0 6.07 6.07 0 0 0 4.41-1.64L26.27 28a3 3 0 0 0 .88-2.13 2.93 2.93 0 0 0-.88-2.11z"/></svg>`;
      const phoneImg = new Image();
      phoneImg.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgPhone);
      phoneImg.onload = () => {
        x -= iconSize + 14;
        ctx.drawImage(phoneImg, x, padding, iconSize, iconSize);
      };

      // --- Лупа ---
      x -= iconSize + 14;
      ctx.strokeStyle = colorIcons;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.arc(x + 7, padding + 7, 5, 0, 2 * Math.PI);
      ctx.moveTo(x + 10, padding + 10);
      ctx.lineTo(x + 14, padding + 14);
      ctx.stroke();

      // --- Tabs ---
      const tabs = ["Супи", "Салати", "Гарніри"];
      const tabWidth = 60;
      const tabHeight = 22;
      const gap = 8;
      const tabY = 135;
      tabs.forEach((tab, i) =>
        drawButton(ctx, 20 + i * (tabWidth + gap), tabY, tabWidth, tabHeight, 5, tab)
      );

      // --- Items ---
      const items = [
        { name: "Рамен", desc: "Японський Рамен", price: 180 },
        { name: "Удон", desc: "Суп удон", price: 150 },
        { name: "Горілка Невіроф 1л.", desc: "Суші", price: 500 },
      ];

      img.src = logoImg;
      img.onload = () => {
        // все малювання тут, тепер картинка гарантовано завантажена
        let y = 160;
        const cardRadius = 8;

        for (const item of items) {
          y += 10;
          const cardX = 15;
          const cardY = y;
          const cardW = canvas.width - 30;
          const cardH = 40;

          ctx.fillStyle = colorBg;
          ctx.strokeStyle = textColor;
          ctx.lineWidth = 0.5;
          drawRoundedRect(ctx, cardX, cardY, cardW, cardH, cardRadius);
          ctx.fill();
          ctx.stroke();

          ctx.drawImage(img, cardX + 5, cardY + 5, 30, 30);

          ctx.fillStyle = textColor;
          ctx.font = "bold 10px Arial";
          ctx.textAlign = "left";
          ctx.fillText(item.name, cardX + 40, cardY + 15);

          ctx.font = "8px Arial";
          ctx.fillText(item.desc, cardX + 40, cardY + 30);

          ctx.textAlign = "right";
          ctx.font = "9px Arial";
          ctx.fillText(item.price + " грн", canvas.width - 25, cardY + 15);

          drawButton(ctx, canvas.width - 60, cardY + 20, 40, 15, 3, "Додати", "bold 9px Courier New");

          y += 40;
        }
      };

      // --- Footer ---
      ctx.fillStyle = textColor;
      ctx.fillRect(0, canvas.height - 20, canvas.width, 20);
      ctx.fillStyle = colorBg;
      ctx.font = "bold 10px Arial";
      ctx.textAlign = "center";
      ctx.fillText("В кошик", canvas.width / 2, canvas.height - 10);
    };
  }, [iconHeader, colorIcons, colorBg, textColor, mainText]);

  return <canvas ref={canvasRef}></canvas>;
}

function SysConstList({ data, actions }) {
  let wndData = ''
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabClose = actions.tabClose

  let qr_data = [];
  let qr = null;

  const context = useContext(dataContext)
  const Data = context.data.sysConst
  const getData = context.getData
  const saveData = context.saveData
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const msg = context.msg
  const loaddata = context.loaddata

  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [showTransMsg, setShowTransMsg] = useState(false);

  const handleSelectedLanguages = (langs, delay = 1000) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    const newTimeout = setTimeout(() => {
      const selectedLangs = langs.filter(lang => lang.is_used === 1 && lang.code !== 'uk');

      msg(localestr('Бажаєте перекласти страви та категорії в онлайн меню?'), localestr('Переклад'),
        [
          {
            caption: 'Так', action: () => {
              loaddata(`action=grpTranslations&data=${JSON.stringify(selectedLangs)}`, undefined, () => { })
            }
          },
          {
            caption: 'Ні', action: () => {
              if (!showTransMsg) {
                setShowTransMsg(!showTransMsg)
              }
            }
          }
        ])

      setDebounceTimeout(null);
    }, delay);

    setDebounceTimeout(newTimeout);
  };

  useEffect(() => {
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [debounceTimeout]);

  const setValue = (name, data) => {
    if (name === 'constPrinter') if (data && parseInt(data.device) > 3) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (name === 'constPrinter') if (data && data.device && parseInt(data.device.value) > 3) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (name === 'constFiscal') if (data && parseInt(data.device) < 4) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (name === 'constFiscal') if (data && data.device && parseInt(data.device.value) < 4) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (name === 'constFiscalCard') if (data && parseInt(data.device) < 4) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (name === 'constFiscalCard') if (data && data.device && parseInt(data.device.value) < 4) { msg(localestr('Невірний тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    let newData = { ...wndData, changed: true }
    if (data === '') newData[name] = null
    else if (name.substring(0, 4) === 'lang') {
      const langCode = name.substring(5)
      const is_used = parseInt(data)
      const langs = wndData.langs || Data.langs
      let newLangs = langs.map((item) => {
        if (item.code === langCode) {
          // if(is_used===0 && langCount-1<1) {
          //     msg(localestr('Мінімум одна мова має бути вибрана'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);
          //     return item
          // }
          langCount = langCount + is_used ? 1 : -1
          item.is_used = is_used

          if (is_used === 1) {
            handleSelectedLanguages(langs);
          }

          return item
        }
        return item
      })
      newData['langs'] = newLangs
    }
    else newData[name] = data
    setWndData(newData)
  }

  const setOpened = (name, data) => {
    let newData = { ...wndData, changed: true }
    if (!newData.constOpened) newData.constOpened = Data.constOpened || {}
    if (data === '') newData.constOpened[name] = null
    else newData.constOpened[name] = data
    setWndData(newData)
  }

  const saveValue = () => {
    let errmsg = ''
    if (!wndData.changed) { tabClose(); return }
    const newData = { ...wndData }
    delete newData.changed
    for (let key in newData) {
      if (key === 'sysFirm' && !newData[key]) errmsg += localestr("Не заповнено назву закладу") + '\n'
      if (key === 'constPrinter' && newData[key]) newData[key] = newData[key].id || 'NULL'
      if (key === 'constFiscal' && newData[key]) newData[key] = newData[key].id || 'NULL'
      if (key === 'constFiscalCard' && newData[key]) newData[key] = newData[key].id || 'NULL'
      if (key === 'constCashbox' && newData[key]) newData[key] = newData[key].id || 'NULL'
      if (key === 'constAccount' && newData[key]) newData[key] = newData[key].id || 'NULL'
      if (key === 'constDelivery' && newData[key]) newData[key] = newData[key].id || 'NULL'
      if (key === 'selectionType') setSettings({ selectionType: newData[key] || '0' })
    }

    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      //console.log(newData)
      let setData = { status: 'mod', key: 'sysConst', data: newData }
      if (showTransMsg) {
        msg(localestr('Бажаєте перекласти страви та категорії в онлайн меню?'), localestr('Переклад'),
          [
            {
              caption: 'Так', action: () => {
                saveData(setData, tabClose)
              }
            },
            {
              caption: 'Ні', action: () => {
                delete setData?.data?.langs
                saveData(setData, tabClose)
              }
            }
          ])
      } else {
        delete setData?.data?.langs
        saveData(setData, tabClose)
      }
    }

  }

  const recalcTTL = (d, wait = true) => {
    if (d) msg(localestr('Операція завершена'), localestr('Інформація'), [{ caption: 'OK', action: () => { } }])
    else if (wait) msg(localestr('Операція може зайняти тривалий час \n будь ласка дочекайдесь її закінчення'), localestr('Інформація'), [{ caption: localestr('Продовжити'), action: () => recalcTTL(null, false) }, { caption: localestr('Відміна'), action: () => { } }])
    else loaddata('action=ttlRecount', null, data => recalcTTL(data))
  }

  function update_lic(d) {
    //console.log(d)
    const newData = { constLicensing: d.data }

    let setData = { status: 'modOk', key: 'sysConst', data: newData }
    saveData(setData, () => { })
  }

  function onFilesChange(e) {
    let reader = new FileReader()
    reader.readAsText(e.target.files[0])
    reader.onload = () => {
      loaddata('action=modLicense&data=' + encodeURIComponent(reader.result), null, data => update_lic(data))
    }

    reader.onerror = () => console.log(reader.error)
  }

  function setImage(name, data) {
    let newData = { ...wndData }
    if (name === 'logo') {
      if (data === '') newData.logo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
      else newData.logo = data
      loaddata('action=modImage&data=' + encodeURIComponent(JSON.stringify({ name: 'logo192.png', data: newData.logo })), null, () => setImage('logoОк', newData.logo))
    }
    if (name === 'baner') {
      if (data === '') newData.baner = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
      else newData.baner = data
      loaddata('action=modImage&data=' + encodeURIComponent(JSON.stringify({ name: 'baner.webp', data: newData.baner })), null, () => setImage('banerОк', newData.baner))
    }
    if (name === 'menu_msq_img') {
      if (data === '') newData.menu_msq_img = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
      else newData.menu_msq_img = data
      loaddata('action=modImage&data=' + encodeURIComponent(JSON.stringify({ name: 'menu_msq_img.webp', data: newData.menu_msq_img })), null, () => setImage('menu_msq_imgОк', newData.menu_msq_img))
    }
    if (name === 'logoОк') newData.logo = data
    if (name === 'banerОк') newData.baner = data
    if (name === 'menu_msq_imgОк') newData.menu_msq_img = data
    setWndData(newData)
  }

  function setValueObj(name, key, data) {
    let newData = { ...wndData, changed: true }
    if (!newData[name]) newData[name] = {}
    if (data === '') newData[name][key] = null
    else newData[name][key] = data
    setWndData(newData)
  }

  function saveEst() {
    loaddata('action=saveEst', null, (d) => { setWndData({ ...wndData, constBotLink: d.data }) })
  }

  useEffect(() => {
    if (!Data) getData('sysConst')
    // eslint-disable-next-line 
  }, [Data])

  if (Data) {
    const sysFirm = wndData.sysFirm !== undefined ? wndData.sysFirm : Data.sysFirm || ''
    const constAdress = wndData.constAdress !== undefined ? wndData.constAdress : Data.constAdress || ''
    const constPhone = wndData.constPhone !== undefined ? wndData.constPhone : Data.constPhone || ''
    const constDescript = wndData.constDescript !== undefined ? wndData.constDescript : Data.constDescript || ''
    const constOpened = wndData.constOpened !== undefined ? wndData.constOpened : Data.constOpened || {};
    const constEmail = wndData.constEmail !== undefined ? wndData.constEmail : Data.constEmail || ''
    const constTelegram = wndData.constTelegram !== undefined ? wndData.constTelegram : Data.constTelegram || ''
    const constCardPay = wndData.constCardPay || Data.constCardPay || '0'
    const constTerminal = wndData.constTerminal || Data.constTerminal || ''
    const constCertPay = wndData.constCertPay || Data.constCertPay || '0'
    const constMinus = wndData.constMinus || Data.constMinus || '0'
    const constExciseMark = wndData.constExciseMark || Data.constExciseMark || '0'
    const constPrinter = wndData.constPrinter || { id: Data.constPrinter }
    const constChangePrint = wndData.constChangePrint || Data.constChangePrint || '0'
    const constQuePrint = wndData.constQuePrint || Data.constQuePrint || '0'
    const constDocPrint = wndData.constDocPrint || Data.constDocPrint || '0'
    const constTurnPrint = wndData.constTurnPrint || Data.constTurnPrint || '0'
    const constTurnTmpl = wndData.constTurnTmpl || Data.constTurnTmpl || '0'
    const constFiscal = wndData.constFiscal || { id: Data.constFiscal }
    const constFiscalCard = wndData.constFiscalCard || { id: Data.constFiscalCard }
    const constFisCash = wndData.constFisCash || Data.constFisCash || '0'
    const constFisCert = wndData.constFisCert || Data.constFisCert || '0'
    const constFisCard = wndData.constFisCard || Data.constFisCard || '0'
    const constFisLess = wndData.constFisLess || Data.constFisLess || '0'
    const constFisMarks = wndData.constFisMarks || Data.constFisMarks || '0'
    const constGroupCheck = wndData.constGroupCheck || Data.constGroupCheck || '0'
    /*const constCashItem=wndData.constCashItem || Data.constCashItem*/
    const constCashbox = wndData.constCashbox || { id: Data.constCashbox }
    const constAccount = wndData.constAccount || { id: Data.constAccount }
    const constDelivery = wndData.constDelivery || { id: Data.constDelivery }
    const constLicensing = (Data.constExpert ? 'expert ' : Data.constStandard ? 'standart ' : 'lite ') + (Data.constLicensing || '')
    const selectionType = wndData.selectionType || getSettings().selectionType || '0'
    const logo = wndData.logo || Data.logo// || '../lib/logo192.png'
    const baner = wndData.baner || Data.baner
    const constOnlTiktok = wndData.constOnlTiktok !== undefined ? wndData.constOnlTiktok : Data.constOnlTiktok || ''
    const constOnlFacebook = wndData.constOnlFacebook !== undefined ? wndData.constOnlFacebook : Data.constOnlFacebook || ''
    const constOnlInstagram = wndData.constOnlInstagram !== undefined ? wndData.constOnlInstagram : Data.constOnlInstagram || ''
    const constOnlGoogle = wndData.constOnlGoogle !== undefined ? wndData.constOnlGoogle : Data.constOnlGoogle || ''
    const constOnlInner = wndData.constOnlInner || Data.constOnlInner || '0'
    const constOnlDelivery = wndData.constOnlDelivery || Data.constOnlDelivery || '0'
    const constOnlPickup = wndData.constOnlPickup || Data.constOnlPickup || '0'
    const constOnlScheme = wndData.constOnlScheme || Data.constOnlScheme || '0'
    const constOnlCash = wndData.constOnlCash || Data.constOnlCash || '0'
    const constOnlCard = wndData.constOnlCard || Data.constOnlCard || '0'
    const constOnlLiqpay = wndData.constOnlLiqpay || Data.constOnlLiqpay || '0'
    const constCaption = wndData.constCaption !== undefined ? wndData.constCaption : Data.constCaption || ''
    const constOnlColor1 = wndData.constOnlColor1 || Data.constOnlColor1 || null
    const constOnlColor2 = wndData.constOnlColor2 || Data.constOnlColor2 || null
    const constOnlColor3 = wndData.constOnlColor3 || Data.constOnlColor3 || null
    const constMenuMsg1 = wndData.constMenuMsg1 !== undefined ? wndData.constMenuMsg1 : Data.constMenuMsg1 || ''
    const constMenuMsg2 = wndData.constMenuMsg2 !== undefined ? wndData.constMenuMsg2 : Data.constMenuMsg2 || ''
    const constMenuMsg3 = wndData.constMenuMsg3 !== undefined ? wndData.constMenuMsg3 : Data.constMenuMsg3 || ''
    const menu_msq_img = wndData.menu_msq_img || Data.menu_msq_img
    const constOferName = wndData.constOferName !== undefined ? wndData.constOferName : Data.constOferName || ''
    const constOferAdress = wndData.constOferAdress !== undefined ? wndData.constOferAdress : Data.constOferAdress || ''
    const constOferOKPO = wndData.constOferOKPO !== undefined ? wndData.constOferOKPO : Data.constOferOKPO || ''
    const constBotLink = wndData.constBotLink !== undefined ? wndData.constBotLink : Data.constBotLink || ''
    const constOferAccount = wndData.constOferAccount !== undefined ? wndData.constOferAccount : Data.constOferAccount || ''
    const constOferBank = wndData.constOferBank !== undefined ? wndData.constOferBank : Data.constOferBank || ''
    const constRulesQR = wndData.constRulesQR !== undefined ? wndData.constRulesQR : Data.constRulesQR || ''
    const constRulesMenu = wndData.constRulesMenu !== undefined ? wndData.constRulesMenu : Data.constRulesMenu || ''
    const key_liqpay = wndData.key_liqpay !== undefined ? wndData.key_liqpay : Data.key_liqpay || null
    const key_mono = wndData.key_mono !== undefined ? wndData.key_mono : Data.key_mono || null
    const constPrintKitchen = wndData.constPrintKitchen || Data.constPrintKitchen || '0'
    const langs = wndData.langs || Data.langs || []

    langCount = langs.filter(item => item.is_used).length
    let cardAcc = ''
    if (parseInt(constCardPay)) cardAcc = <EditCtrl Capt={localestr('Рахунок (при оплаті карткою)')} Value={constAccount} typeVal={'catCashAccs'} setVal={(d) => { setValue('constAccount', d) }} width1='220' width2='217' />
    let fisMarks = ''
    if (parseInt(constExciseMark)) fisMarks = <EditCtrl Capt={localestr('Фіскалізація акцизних марок')} Value={constFisMarks} typeVal={'selFiscalMarks'} setVal={(d) => { setValue('constFisMarks', d) }} width1='215' width2='222' />
    let fisCert = ''
    if (parseInt(constCertPay)) fisCert = <EditCtrl Capt={localestr('Фіскалізація чека сертифікатом')} Value={constFisCert} typeVal={'selFiscalTypes'} setVal={(d) => { setValue('constFisCert', d) }} width1='215' width2='222' />
    let liqpay = null
    if (!key_liqpay || typeof key_liqpay === 'object') {
      liqpay = <>
        <EditCtrl Capt={localestr('Public Key')} Value={(key_liqpay || {}).public_key} typeVal={'text'} setVal={(d) => { setValueObj('key_liqpay', 'public_key', d) }} width1='80' width2='257' />
        <EditCtrl Capt={localestr('Private Key')} Value={(key_liqpay || {}).privat_key} typeVal={'text'} setVal={(d) => { setValueObj('key_liqpay', 'privat_key', d) }} width1='80' width2='257' />
      </>
    } else {
      liqpay = <div>
        <div style={{ width: '200px', display: 'inline-block', verticalAlign: 'bottom', float: 'right' }} className={'key_btn'} onClick={() => { setValue('key_liqpay', null) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Змінити налаштування')}</div></div>
        <span style={{ fontSize: 'small', fontStyle: 'italic', color: 'blue' }}>
          {localestr('LiqPay налаштовано. Дані використовуються для поділу оплати на різних ФОПів.')}
        </span></div>
    }

    let monobank = null
    if (!key_mono || typeof key_mono === 'object') {
      monobank = <>
        <EditCtrl Capt={localestr('Public Key')} Value={(key_mono || {}).public_key} typeVal={'text'} setVal={(d) => { setValueObj('key_mono', 'public_key', d) }} width1='80' width2='257' />
        <EditCtrl Capt={localestr('Private Key')} Value={(key_mono || {}).privat_key} typeVal={'text'} setVal={(d) => { setValueObj('key_mono', 'privat_key', d) }} width1='80' width2='257' />
      </>
    } else {
      monobank = <div>
        <div style={{ width: '200px', display: 'inline-block', verticalAlign: 'bottom', float: 'right' }} className={'key_btn'} onClick={() => { setValue('key_mono', null) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Змінити налаштування')}</div></div>
        <span style={{ fontSize: 'small', fontStyle: 'italic', color: 'blue' }}>
          {localestr('MonoBank налаштовано. Дані використовуються основний засіб оплати.')}
        </span></div>
    }

    if (constBotLink && constBotLink !== '') {
      qr_data.push({
        name: 'bot',
        data: createQR(
          constBotLink,
          null,
          {
            color2: '#000000',
            qr_stl: 5,
          }
        )
      })
      qr = qr_data.map((el, idx) =>
        <img key={idx} style={{ width: '60mm', margin: '10px' }} src={el.data} alt='' />
      )
    }
    const catTerminals = (context.data.catDevices || []).filter(item => item.device === '7').map(item => { return { value: item.id, name: item.name } })
    let terminal = ''
    if(parseInt(constCardPay||0)) terminal = <EditCtrl Capt={localestr('Термінал (за замовчуванням)')} Value={constTerminal} typeVal={'selUserType'} userData={catTerminals} setVal={(d) => { setValue('constTerminal', d) }} width1='235' width2='202' />

    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '2px 3px' }}>
        <Panel caption={'Відомості про заклад'} width={580} height={900} open={wndData.p_info === undefined ? true : wndData.p_info} setOpen={d => setWndData({ ...wndData, p_info: d })}>
          <EditCtrl Capt={localestr('Назва закладу')} Value={sysFirm} typeVal={'text'} setVal={(d) => { setValue('sysFirm', d) }} width1='108' width2='470' />
          <div style={{ margin: '2px 1px', display: 'inherit' }}>
            <EditCtrl Capt={localestr('Адреса')} Value={constAdress} typeVal={'text'} setVal={(d) => { setValue('constAdress', d) }} width1='56' width2='350' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('Телефон')} Value={constPhone} typeVal={'text'} setVal={(d) => { setValue('constPhone', d) }} width1='64' width2='100' />
          </div>
          <div style={{ margin: '2px 1px', display: 'inherit' }}>
            <EditCtrl Capt={localestr('e-mail')} Value={constEmail} typeVal={'text'} setVal={(d) => { setValue('constEmail', d) }} width1='56' width2='224' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('Telegram')} Value={constTelegram} typeVal={'text'} setVal={(d) => { setValue('constTelegram', d) }} width1='66' width2='224' />
          </div>
          <EditCtrl Capt={localestr('Інформація про заклад')} Value={constDescript} typeVal={'longtext'} setVal={(d) => { setValue('constDescript', d) }} width1='80' width2='498' />
          <Panel caption={'Графік роботи'} width={580} open={wndData.p_open === undefined ? false : wndData.p_open} setOpen={d => setWndData({ ...wndData, p_open: d })}>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <EditCtrl Capt={localestr('Понеділок')} Value={constOpened.mn_from} typeVal={'time'} setVal={(d) => { setOpened('mn_from', d) }} width1='80' width2='75' />
              <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
              <EditCtrl Capt={'-'} Value={constOpened.mn_to} typeVal={'time'} setVal={(d) => { setOpened('mn_to', d) }} width1='14' width2='75' />
              <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
            </div>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <EditCtrl Capt={localestr('Вівторок')} Value={constOpened.tu_from} typeVal={'time'} setVal={(d) => { setOpened('tu_from', d) }} width1='80' width2='75' />
              <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
              <EditCtrl Capt={'-'} Value={constOpened.tu_to} typeVal={'time'} setVal={(d) => { setOpened('tu_to', d) }} width1='14' width2='75' />
              <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
            </div>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <EditCtrl Capt={localestr('Середа')} Value={constOpened.ve_from} typeVal={'time'} setVal={(d) => { setOpened('ve_from', d) }} width1='80' width2='75' />
              <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
              <EditCtrl Capt={'-'} Value={constOpened.ve_to} typeVal={'time'} setVal={(d) => { setOpened('ve_to', d) }} width1='14' width2='75' />
              <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
            </div>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <EditCtrl Capt={localestr('Четвер')} Value={constOpened.th_from} typeVal={'time'} setVal={(d) => { setOpened('th_from', d) }} width1='80' width2='75' />
              <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
              <EditCtrl Capt={'-'} Value={constOpened.th_to} typeVal={'time'} setVal={(d) => { setOpened('th_to', d) }} width1='14' width2='75' />
              <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
            </div>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <EditCtrl Capt={localestr('П\'ятниця')} Value={constOpened.fr_from} typeVal={'time'} setVal={(d) => { setOpened('fr_from', d) }} width1='80' width2='75' />
              <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
              <EditCtrl Capt={'-'} Value={constOpened.fr_to} typeVal={'time'} setVal={(d) => { setOpened('fr_to', d) }} width1='14' width2='75' />
              <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
            </div>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <EditCtrl Capt={localestr('Субота')} Value={constOpened.sa_from} typeVal={'time'} setVal={(d) => { setOpened('sa_from', d) }} width1='80' width2='75' />
              <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
              <EditCtrl Capt={'-'} Value={constOpened.sa_to} typeVal={'time'} setVal={(d) => { setOpened('sa_to', d) }} width1='14' width2='75' />
              <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
            </div>
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <EditCtrl Capt={localestr('Неділя')} Value={constOpened.su_from} typeVal={'time'} setVal={(d) => { setOpened('su_from', d) }} width1='80' width2='75' />
              <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
              <EditCtrl Capt={'-'} Value={constOpened.su_to} typeVal={'time'} setVal={(d) => { setOpened('su_to', d) }} width1='14' width2='75' />
              <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
            </div>
          </Panel>
          <EditImg Capt={localestr('Логотип') + ' (192x192)'} Value={logo} setVal={(d) => { setImage('logo', d) }} width1='40' width2='160' height2='160' img_width={192} img_height={192} />
        </Panel>
        <Panel caption={'Налаштування друку'} width={580} open={wndData.p_prin === undefined ? false : wndData.p_prin} setOpen={d => setWndData({ ...wndData, p_prin: d })}>
          <EditCtrl Capt={localestr('Чековий принтер')} Value={constPrinter} typeVal={'catDevices'} setVal={(d) => { setValue('constPrinter', d) }} width1='170' width2='267' />
          <EditCtrl Capt={localestr('Друкувати не фіскальний чек')} Value={constDocPrint} typeVal={'selYNQ'} setVal={(d) => { setValue('constDocPrint', d) }} width1='235' width2='202' />
          <EditCtrl Capt={localestr('Групування позицій в рахунку')} Value={constGroupCheck} typeVal={'selUserType'} userData={[{ name: 'Не групувати', value: '0' }, { name: 'По підрозділах', value: '1' }, { name: 'По програмних РРО', value: '2' }]} setVal={(d) => { setValue('constGroupCheck', d) }} width1='235' width2='202' />
          <EditCtrl Capt={localestr('Друкувати відмову')} Value={constTurnPrint} typeVal={'selYNQ'} setVal={(d) => { setValue('constTurnPrint', d) }} width1='235' width2='202' />
          <EditCtrl Capt={localestr('Друкувати зміну кількості')} Value={constChangePrint} typeVal={'selYNQ'} setVal={(d) => { setValue('constChangePrint', d) }} width1='235' width2='202' />
          <EditCtrl Capt={localestr('Друкувати чергу подачі')} Value={constQuePrint} typeVal={'selYNQ'} setVal={(d) => { setValue('constQuePrint', d) }} width1='235' width2='202' />
          <EditCtrl Capt={localestr('Обов`язковий друк на кухню')} Value={constPrintKitchen} typeVal={'selYN'} setVal={(d) => { setValue('constPrintKitchen', d) }} width1='235' width2='202' />
        </Panel>
        <Panel caption={'Фіскалізація чеків'} width={580} open={wndData.p_fisk === undefined ? false : wndData.p_fisk} setOpen={d => setWndData({ ...wndData, p_fisk: d })}>
          {/*<EditCtrl Capt={localestr('Вести реєстр акцизних марок')} Value={constExciseMark} typeVal={'selYN'} setVal={(d) => { setValue('constExciseMark', d) }} width1='235' width2='202' />*/}
          <EditCtrl Capt={localestr('Основний фіскальний реєстратор (по замовчуванню)')} Value={constFiscal} typeVal={'catDevices'} setVal={(d) => { setValue('constFiscal', d) }} width1='330' width2='107' />
          <EditCtrl Capt={localestr('Додатковий фіскальний реєстратор (лише картка)')} Value={constFiscalCard} typeVal={'catDevices'} setVal={(d) => { setValue('constFiscalCard', d) }} width1='330' width2='107' />
          <EditCtrl Capt={localestr('Фіскалізація чека готівкою')} Value={constFisCash} typeVal={'selFiscalTypes'} setVal={(d) => { setValue('constFisCash', d) }} width1='195' width2='242' />
          <EditCtrl Capt={localestr('Фіскалізація чека карткою')} Value={constFisCard} typeVal={'selFiscalTypes'} setVal={(d) => { setValue('constFisCard', d) }} width1='195' width2='242' />
          <EditCtrl Capt={localestr('Фіскалізація по перерахунку')} Value={constFisLess} typeVal={'selFiscalTypes'} setVal={(d) => { setValue('constFisLess', d) }} width1='205' width2='232' />
          {fisCert}{fisMarks}
        </Panel>
        {/*<EditCtrl disabled={true} Capt={localestr('Стаття руху коштів "виручка"')} Value={constCashItem} typeVal={'text'} setVal={(d)=>{setValue('constCashItem',d)}} width1='220' width2='117'/>
                <EditCtrl Capt={localestr('Замовлення на доставку онлайн')} Value={constDelivery} typeVal={'selYN'} setVal={(d)=>{setValue('constDelivery',d)}} width1='235' width2='102'/>
            */}
        <Panel caption={'Загальні налаштування'} width={580} open={wndData.p_tuns === undefined ? false : wndData.p_tuns} setOpen={d => setWndData({ ...wndData, p_tuns: d })}>
          <EditCtrl Capt={localestr('Можливість оплати карткою')} Value={constCardPay} typeVal={'selYN'} setVal={(d) => { setValue('constCardPay', d) }} width1='235' width2='202' />
          {terminal}
          <EditCtrl Capt={localestr('Можливість оплати сертифікатом')} Value={constCertPay} typeVal={'selYN'} setVal={(d) => { setValue('constCertPay', d) }} width1='235' width2='202' />
          <EditCtrl Capt={localestr('Можливість від\'ємних залишків')} Value={constMinus} typeVal={'selYNttl'} setVal={(d) => { setValue('constMinus', d) }} width1='235' width2='202' />
          <EditCtrl Capt={localestr('Використовувати шаблони відмови')} Value={constTurnTmpl} typeVal={'selYN'} setVal={(d) => { setValue('constTurnTmpl', d) }} width1='265' width2='172' />
          <EditCtrl Capt={localestr('Основна каса (при продажу)')} Value={constCashbox} typeVal={'catCashAccs'} setVal={(d) => { setValue('constCashbox', d) }} width1='220' width2='217' />
          {cardAcc}
          <EditCtrl Capt={localestr('Послуга доставки')} Value={constDelivery} typeVal={'catGoods'} setVal={(d) => { setValue('constDelivery', d) }} width1='220' width2='217' />
          <EditCtrl Capt={localestr('Режим підбору в документах')} Value={selectionType} typeVal={'selSelectionType'} setVal={(d) => { setValue('selectionType', d) }} width1='200' width2='237' />
        </Panel>
        <Panel caption={'Телеграм сповіщення'} width={580} open={wndData.p_bot === undefined ? false : wndData.p_bot} setOpen={d => setWndData({ ...wndData, p_bot: d })}>
          {constBotLink && constBotLink.length > 0 ? (
            <>
              <div style={{ margin: '0 3px', display: 'inlineFlex', lineHeight: '24px', width: '100%' }}>{localestr('Щоб перейти до бота та почати його використовувати, використай посилання або QR-код знизу')}</div>
              <a href={constBotLink}>Нажміть на це посилання що перейти до бота</a>
              {qr}
            </>
          ) : (
            <>
              <div style={{ margin: '0 3px', display: 'inlineFlex', lineHeight: '24px', width: '100%' }}>{localestr('На разі ваш заклад не авторизовано в системі сповіщень, це можна зробити натиснувши кнопку знизу.')}</div>
              <div style={{ width: '200px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveEst() }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зареєструвати заклад')}</div></div>
            </>
          )}
        </Panel>
        <Panel caption={localestr('Онлайн меню')} width={580} height={1520} open={wndData.p_onln === undefined ? false : wndData.p_onln} setOpen={d => setWndData({ ...wndData, p_onln: d })}>
          <div style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ margin: '0 3px', display: 'inlineFlex', lineHeight: '24px', width: '100%' }}>{localestr('Приймати онлайн замовлення')}</div>
            <EditCtrl Capt={localestr('у закладі')} Value={constOnlInner} typeVal={'l_check'} setVal={(d) => { setValue('constOnlInner', d) }} width1='95' width2='192' />
            <EditCtrl Capt={localestr('на доставку')} Value={constOnlDelivery} typeVal={'l_check'} setVal={(d) => { setValue('constOnlDelivery', d) }} width1='95' width2='192' />
            <EditCtrl Capt={localestr('самовивіз')} Value={constOnlPickup} typeVal={'l_check'} setVal={(d) => { setValue('constOnlPickup', d) }} width1='95' width2='192' />
          </div>
          <EditCtrl Capt={localestr('Онлайн оплата')} Value={constOnlScheme} typeVal={'selOnlinePay'} setVal={(d) => { setValue('constOnlScheme', d) }} width1='115' width2='222' />
          <div style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ margin: '0 3px', display: 'inlineFlex', lineHeight: '24px', width: '100%' }}>{localestr('Види оплати при доставці')}</div>
            <EditCtrl Capt={localestr('готівкою')} Value={constOnlCash} typeVal={'l_check'} setVal={(d) => { setValue('constOnlCash', d) }} width1='105' width2='192' />
            <EditCtrl Capt={localestr('карткою')} Value={constOnlCard} typeVal={'l_check'} setVal={(d) => { setValue('constOnlCard', d) }} width1='105' width2='192' />
            <EditCtrl Capt={localestr('liqpay')} Value={constOnlLiqpay} typeVal={'l_check'} setVal={(d) => { setValue('constOnlLiqpay', d) }} width1='105' width2='192' />
          </div>
          {langs && langs.length !== 0 &&
            <div style={{ margin: '2px 0', display: 'inherit' }}>
              <div style={{ margin: '0 3px', display: 'inlineFlex', lineHeight: '24px', width: '100%' }}>{localestr('Переклади на іноземні мови')}</div>
              {langs
                .filter(l => l.code !== 'uk')
                .map((item) => {
                  return <EditCtrl key={item.id} Capt={item.name} Value={item.is_used} typeVal={'l_check'} setVal={(d) => { setValue(`lang_${item.code}`, d) }} width1='105' width2='192' />
                })}
            </div>
          }

          <Panel caption={localestr('Налаштування liqpay')} width={580} open={wndData.p_liq === undefined ? false : wndData.p_liq} setOpen={d => setWndData({ ...wndData, p_liq: d })}>
            {liqpay}
          </Panel>
          <Panel caption={localestr('Налаштування monobank')} width={580} open={wndData.p_mono === undefined ? false : wndData.p_mono} setOpen={d => setWndData({ ...wndData, p_mono: d })}>
            {monobank}
          </Panel>
          <Panel caption={localestr('Посилання на соціальні мережі')} width={580} open={wndData.p_soc === undefined ? true : wndData.p_soc} setOpen={d => setWndData({ ...wndData, p_soc: d })}>
            <EditCtrl Capt={localestr('facebook')} Value={constOnlFacebook} typeVal={'text'} setVal={(d) => { setValue('constOnlFacebook', d) }} width1='75' width2='262' />
            <EditCtrl Capt={localestr('instagram')} Value={constOnlInstagram} typeVal={'text'} setVal={(d) => { setValue('constOnlInstagram', d) }} width1='75' width2='262' />
            <EditCtrl Capt={localestr('tiktok')} Value={constOnlTiktok} typeVal={'text'} setVal={(d) => { setValue('constOnlTiktok', d) }} width1='75' width2='262' />

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <EditCtrl Capt={localestr('google відгуки')} Value={constOnlGoogle} typeVal={'text'} setVal={(d) => { setValue('constOnlGoogle', d) }} width1='110' width2='217' />
              <div><Info info={
                <div>
                  <p>Google відгуки - це функція сервісу Google, яка дозволяє користувачам залишати оцінки та відгуки про ваш заклад</p>
                  <i> Для додавання посилання на відгуки потрібно мати Google
                    Business Profile
                  </i>
                  <p>Знайдіть і виберіть ваш заклад в Google Maps</p>
                  <p>Виберіть панель "Відгуки" і скопіюйте URL посилання</p>
                </div>
              } url={'https://cocktail.org.ua/wiki/administration/google-reviews'} /></div>
            </div>
          </Panel>
          <Panel caption={localestr('Зовнішній вигляд сторінки')} width={580} open={wndData.p_view === undefined ? false : wndData.p_view} setOpen={d => setWndData({ ...wndData, p_view: d })}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ margin: '3px 3px -3px 3px', display: 'inlineFlex', lineHeight: '20px', width: '100%' }}>{localestr('Банер 1820х830')}</div>
                <EditImg Capt={''} Value={baner} setVal={(d) => { setImage('baner', d) }} width1='0' width2='364' height2='166' img_width={1820} img_height={830} img_transp={false} />
                <EditCtrl Capt={localestr('Назва на банері')} Value={constCaption} typeVal={'text'} setVal={(d) => { setValue('constCaption', d) }} width1='122' width2='215' />
                <EditCtrl Capt={localestr('Колір тексту та піктограм на банері')} Value={constOnlColor1} typeVal={'color'} setVal={(d) => { setValue('constOnlColor1', d) }} width1='262' width2='75' />
                <EditCtrl Capt={localestr('Загальний фон сторінки')} Value={constOnlColor2} typeVal={'color'} setVal={(d) => { setValue('constOnlColor2', d) }} width1='262' width2='75' />
                <EditCtrl Capt={localestr('Колір тексту')} Value={constOnlColor3} typeVal={'color'} setVal={(d) => { setValue('constOnlColor3', d) }} width1='262' width2='75' />
              </div>
              <div className="">
                <MenuCanvas iconHeader={baner} colorIcons={constOnlColor1?.src} colorBg={constOnlColor2?.src} textColor={constOnlColor3?.src} mainText={constCaption} />
              </div>
            </div>
          </Panel>
          <Panel caption={localestr('Інформаційні повідомлення')} width={580} open={wndData.p_info === undefined ? false : wndData.p_info} setOpen={d => setWndData({ ...wndData, p_info: d })}>
            <div style={{ margin: '3px 3px -3px 3px', display: 'inlineFlex', lineHeight: '20px', width: '100%' }}>{localestr('Спливаюче повідомлення при вході')}</div>
            <EditCtrl Capt={''} Value={constMenuMsg1} typeVal={'text'} setVal={(d) => { setValue('constMenuMsg1', d) }} width1='0' width2='337' />
            <div style={{ margin: '3px 3px -3px 3px', display: 'inlineFlex', lineHeight: '20px', width: '100%' }}>{localestr('Заставка для повідомлення 500х500')}</div>
            <EditImg Capt={''} Value={menu_msq_img} setVal={(d) => { setImage('menu_msq_img', d) }} width1='0' width2='200' height2='200' img_width={500} img_height={500} img_transp={false} />
            <div style={{ margin: '3px 3px -3px 3px', display: 'inlineFlex', lineHeight: '20px', width: '100%' }}>{localestr('Інформаційне повідомлення у корзині')}</div>
            <EditCtrl Capt={''} Value={constMenuMsg2} typeVal={'text'} setVal={(d) => { setValue('constMenuMsg2', d) }} width1='0' width2='337' />
            <div style={{ margin: '3px 3px -3px 3px', display: 'inlineFlex', lineHeight: '20px', width: '100%' }}>{localestr('Інформаційне повідомлення на сторінці оформлення доставки')}</div>
            <EditCtrl Capt={''} Value={constMenuMsg3} typeVal={'text'} setVal={(d) => { setValue('constMenuMsg3', d) }} width1='0' width2='337' />
          </Panel>
          <Panel caption={localestr('Правила роботи закладу')} width={580} open={wndData.p_rules === undefined ? false : wndData.p_rules} setOpen={d => setWndData({ ...wndData, p_rules: d })}>
            <EditCtrl Capt={localestr('Правила роботи закладу (QR меню)')} Value={constRulesQR} typeVal={'longtext'} setVal={(d) => { setValue('constRulesQR', d) }} width1='80' width2='498' />
            <EditCtrl Capt={localestr('Умови доставки і оплати (Online)')} Value={constRulesMenu} typeVal={'longtext'} setVal={(d) => { setValue('constRulesMenu', d) }} width1='80' width2='498' />
          </Panel>
          <Panel caption={localestr('Офіційні дані публічної оферти')} width={580} open={wndData.p_ofer === undefined ? false : wndData.p_ofer} setOpen={d => setWndData({ ...wndData, p_ofer: d })}>
            <EditCtrl Capt={localestr('Юридична назва')} Value={constOferName} typeVal={'text'} setVal={(d) => { setValue('constOferName', d) }} width1='137' width2='200' />
            <EditCtrl Capt={localestr('Юридична адреса')} Value={constOferAdress} typeVal={'text'} setVal={(d) => { setValue('constOferAdress', d) }} width1='137' width2='200' />
            <EditCtrl Capt={localestr('Код ЄДРПОУ')} Value={constOferOKPO} typeVal={'text'} setVal={(d) => { setValue('constOferOKPO', d) }} width1='137' width2='200' />
            <EditCtrl Capt={localestr('IBAN № рахунку')} Value={constOferAccount} typeVal={'text'} setVal={(d) => { setValue('constOferAccount', d) }} width1='137' width2='200' />
            <EditCtrl Capt={localestr('В банку')} Value={constOferBank} typeVal={'text'} setVal={(d) => { setValue('constOferBank', d) }} width1='137' width2='200' />
          </Panel>
        </Panel>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <EditCtrl Capt={localestr('Ліцензія')} Value={constLicensing} typeVal={'text'} setVal={(d) => { setValue('constLicensing', d) }} disabled={true} width1='70' width2='267' />
          <label htmlFor={'lic'}>
            <input id={'lic'} style={{ display: 'none' }} type='file' accept='.bin' onChange={onFilesChange} />
            <div tabIndex='0' className='toolBarItem' style={{ width: '22px', height: '22px', marginTop: '2px', marginLeft: '-24px' }} title={localestr('Редагувати') + ' (Ins)'}>
              <img style={{ width: '18px', height: '18px', margin: '2px' }} src={icon + '#b402'} alt={localestr('Редагувати')} />
            </div>
          </label>
        </div>
        <div style={{ margin: '10px 0 0 0', width: '337px', display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '75px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue() }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          <div style={{ width: '200px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { recalcTTL() }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Перерахувати підсумки')}</div></div>
        </div>
      </div>
    )
  }
  return ('')

}

export default SysConstList